import { PORTAL_MAP_IMG_URL } from '@flowwai-frontend/shared/constants'

import { LOGIN_BG_IMG } from '../constants'
import { ClientConfigType, ClientWebAppMobileConfigType } from './types'

const config: ClientConfigType = {
   rightRegistered: 'Developed by Deepwork Technologies Pvt Ltd',
   login: {
      logoURL: '/assets/images/ma_ud_app_logo_v8.svg',
      mediumLogoURL: '/assets/images/ma_ud_app_logo_v8.svg',
      logoWidth: 336
   },
   navbar: {
      logoURL: '/assets/images/officer_portals_nav_logo_v5.svg'
   },
   enableSupportRequest: false,
   loginLayout: {
      type: 'LEFT_ALIGNED',
      footerImageUrl:
         'https://assets.floww.ai/Gamma/customer-portal/portals-login-footer-banner-desktop-v4.png',
      footerHeight: 115,
      bgImgUrl: LOGIN_BG_IMG,
      poster: {
         imageUrl: PORTAL_MAP_IMG_URL,
         patternUrl: '/assets/images/ma-ud-bg-pattern.png'
      },
      titleConfig: {
         name: 'SRI A. REVANTH REDDY',
         salutation: ["Hon'ble Chief Minister", 'Minister, MA&UD of Telangana'],
         salutationColor: '#194185',
         nameColor: '#194185'
      }
   },
   privacyPolicyAndTC: {
      privacyPolicyUrl: 'https://buildnow.telangana.gov.in/privacy-policy',
      termsAndConditionsUrl:
         'https://buildnow.telangana.gov.in/terms-and-conditions'
   }
}

export default config

export const maAndUdWebAppMobileScreenConfig: ClientWebAppMobileConfigType = {
   appLogo: 'assets/images/tg_maud_webapp_mobile_screen_logo.svg',
   appPreviewImageUrl: '/icons/maud-webapp-mobile-screen.svg',
   bgImageUrl: '/images/maud-webapp-mobile-screen-bg-image.svg'
}
